import { gql } from "@apollo/client";

export const CREATE_STUDENT_BOOK = gql`
  mutation CreateStudentBook($input: StudentBookInput) {
    createStudentBook(input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;


export const GET_STUDENT_BOOK_PAGINATION = gql`
  query GetStudentBookPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $studentId: ID
    $academicYearId: ID 
    $classId: ID
  ) {
    getStudentBookPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      studentId: $studentId
      academicYearId: $academicYearId 
      classId: $classId
    ) {
      data {
        _id
        academicYearId {
          academicYear
          _id
        }
        enrollmentId {
          _id
          classId {
            _id
            className
            gradeId {
              _id
              gradeName
            }
          }
          invoices {
            invoiceId
            additionalFee {
              incomeHead {
                _id
                incomeType
                incomeHead
                note
                price
              }
              additionalFeeTotal
              countMonth
              total
            }
          }
        }
        createdAt
        date
        createdBy {
          _id
          mainUserId {
            firstName
            latinName
            lastName
            imageSrc
          }
        }
        remark
        studentId {
          _id
          firstName
          lastName
          englishName
          nickName
          gender
          profileImg
        }
        warehouseId {
          _id
          imageSrc
          location
          warehouseName
        }
        provideBooks {
          qty
          sellQty
          listMaterialUnitId {
            _id
            materialId {
              _id
              isbm
              materialEnName
              materialKhName    
              groupId {
                _id
                groupKhName
                groupEnName
              }
              sectionId {
                _id
                sectionEnName
                sectionKhName
              }
              levelSectionId {
                _id
                levelSectionEnName
                levelSectionKhName
              }
            }
            imageSrc
            unitId {
              _id
              unitEnName
              unitKhName
            } 
            qtyInUnit
            costPerUnit
            barcode
            isUse
            remark
          }
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPADATE_STUDENT_BOOK = gql`
  mutation UpdateStudentBook($id: ID!, $input: StudentBookInput) {
    updateStudentBook(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_STUDENT_BOOK = gql`
  mutation DeleteStudentBook($id: ID!) {
    deleteStudentBook(_id: $id) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;
